// src/Pages/ProductDetail.js
import { useParams, Link as RouterLink } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Image,
  Container,
  SimpleGrid,
  Stack,
  Button,
  Flex,
} from "@chakra-ui/react";
import { ProductsData } from "../../data/products";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function ProductDetail() {
  const { category, id } = useParams();
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
  };

  // Fetch products based on category
  const product = (ProductsData()[category] || []).find((p) => p.id === id);

  if (!product)
    return (
      <Text textAlign="center" fontSize="lg" color="red.500">
        {isArabic ? "المنتج غير موجود" : "Product not found"}
      </Text>
    );

  // Motion wrappers
  const MotionHeading = motion(Heading);
  const MotionButton = motion(Button);
  const MotionImage = motion(Image);
  const MotionText = motion(Text);

  return (
    <Box
      bg="gray.50"
      py={16}
      px={4}
      minH="100vh"
      dir={isArabic ? "rtl" : "ltr"}
    >
      <Container maxW="6xl">
        {/* Product Title */}
        <MotionHeading
          mb={10}
          textAlign="center"
          size="2xl"
          fontWeight="bold"
          color="teal.600"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {product.title}
        </MotionHeading>

        {/* Request Quote Button */}
        <Flex justify="center" mb={12}>
          <MotionButton
            as={RouterLink}
            to="/request-quotes"
            size="lg"
            borderRadius="full"
            px={8}
            fontWeight="semibold"
            bgGradient={`linear(to-r, ${colors.teal}, ${colors.tealLight})`}
            color="white"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            {isArabic ? "طلب عرض سعر" : "Request a Quote"}
          </MotionButton>
        </Flex>

        {/* Product Images Gallery */}
{product.innerImages && product.innerImages.length > 0 && (
  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={16}>
    {product.innerImages.map((img, index) => (
      <MotionImage
        key={index}
        src={img}
        alt={`${product.title}-image-${index}`}
        borderRadius="xl"
        boxShadow="lg"
        objectFit="cover"
        w="100%"
        h="350px"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
      />
    ))}
  </SimpleGrid>
)}


      {/* Sections (Text Content) */}
<Stack spacing={16}>
  {product.sections.map((section, idx) => (
    <MotionText
      key={idx}
      fontSize="lg"
      color="gray.600"
      maxW="5xl"
      mx="auto"
      dangerouslySetInnerHTML={{ __html: section.body }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    />
  ))}
</Stack>

      </Container>
    </Box>
  );
}
